export const env = { 
  ...import.meta.env,   // Vite build-time values (VITE_* only)
  ...(window.env ?? {}) // react-inject-env runtime values
 }